import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "layout/header/Header";
import Main from "layout/main/Main";
import {
    Home,
    About,
    Services,
    Contact,
    PageNotFound,
} from "routes/publicRoutes";
import MediaPlayerContext from "context/media_player/MediaPlayerContext";
import Footer from "layout/footer/Footer";

const PublicViewsLayout = () => {
    const location = useLocation();

    const isHomePage = location.pathname === '/';
    
    return (
        <>
            <MediaPlayerContext>
                <Header />
                <Main>
                    <Routes>
                        <Route path="" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<PageNotFound />} />
                    </Routes>
                </Main>
                {!isHomePage && <Footer />}
            </MediaPlayerContext>
        </>
    );
};

export default PublicViewsLayout;
